// utils/onboardingSync.js
const channel = new BroadcastChannel('onboarding-sync');

export function notifyTaskCompleted(taskId) {
  channel.postMessage({ type: 'TASK_COMPLETED', taskId });
}

export function listenOnboardingUpdates(store) {
  channel.onmessage = event => {
    const { type, taskId } = event.data || {};
    if (type === 'TASK_COMPLETED') {
      store.commit('onboarding/MARK_LOCAL_TASK_COMPLETED', taskId);
    }
  };
}